import { Component, ViewEncapsulation, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { FileUtil } from '../../util/file.util';
import { FileTypes } from '../../enums/file-types';

@Component({
  selector: 'mi-attachment-icon',
  templateUrl: './attachment-icons.component.html',
  styleUrls: ['attachment-icons.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AttachmentIconsComponent {
  // Signal-based input
  attachmentName = input.required<string>();

  // Computed signals for derived state
  attachmentExtension = computed(() => {
    const extension = FileUtil.getExtFromFileName(this.attachmentName());
    return extension ? extension.toUpperCase() : '';
  });

  fontSize = computed(() => {
    const extension = this.attachmentExtension();
    return extension.length > 3 ? '0.5rem' : '0.625rem';
  });

  attachmentClass = computed(() => {
    const type = FileUtil.getFileTypeFromName(this.attachmentName());
    switch (type) {
      case FileTypes.PDF:
        return 'attachment-icon-pdf';
      case FileTypes.PSD:
        return 'attachment-icon-psd';
      case FileTypes.AI:
        return 'attachment-icon-ai';
      case FileTypes.POWERPOINT:
        return 'attachment-icon-ppt';
      case FileTypes.EXCEL:
        return 'attachment-icon-xls';
      case FileTypes.WORD:
        return 'attachment-icon-doc';
      default:
        return 'attachment-icon';
    }
  });
}
